var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.105 6.29A15 15 0 1035 20v-1.533a1.667 1.667 0 113.333 0V20a18.336 18.336 0 01-13.135 17.572 18.333 18.333 0 112.264-34.328 1.667 1.667 0 01-1.357 3.045z",
    fill: "#00C77E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.845 5.488c.65.65.651 1.705 0 2.357L21.18 24.528a1.667 1.667 0 01-2.357 0l-5-5a1.667 1.667 0 112.357-2.356l3.82 3.82L35.487 5.49a1.667 1.667 0 012.358-.001z",
    fill: "#00C77E"
  })));
}

export default SvgCheckCircle;